import React from 'react'
import {Link} from "react-router-dom";
import {HomeBi, CollectionBi, Folder2OpenBi} from "../../assets/svg/icon";
import CustomIcon from "../util-components/CustomIcon";

function Footer(props) {
  const {routeInfo} = props;
  const getClassName = (key) => {
    return routeInfo?.key === key ? 'menu-item-selected' : '';
  }

	return (
		<footer className="footer">
			{/*<span>Copyright  &copy;  {`${new Date().getFullYear()}`} <span className="font-weight-semibold">{`${APP_NAME}`}</span> All rights reserved.</span>*/}

      <Link to={'/app/shipping/shipping-list'} className={getClassName('shippingList')} >
        <CustomIcon svg={HomeBi}/><span style={{marginTop: -5}}>Shipping</span>
      </Link>
      <Link to={'/app/payments/payments-list'} className={getClassName('payments-paymentsList')} >
        <CustomIcon svg={CollectionBi}/><span>Payments</span>
      </Link>
      <Link to={'/app/carfax'} className={getClassName('carfax')} >
        <CustomIcon svg={Folder2OpenBi}/><span>Carfax</span>
      </Link>

    </footer>
	)
}

export default Footer;